<template>
  <div class="h-100 d-flex flex-column">
    <div class="sidebar-top">
      <div class="sidebar-item">
        <export-btn></export-btn>
      </div>
      <div class="sidebar-item">
        <job-queued></job-queued>
      </div>
      <div class="sidebar-item">
        <rating></rating>
      </div>
      <div class="sidebar-item feedback-item">
        <feedback></feedback>
      </div>
      <div class="sidebar-item"  v-if="projectName === 'Img2Go'">
        <continue-with></continue-with>
      </div>
      <div class="sidebar-item feedback-item feedback-item-bg" v-if="projectName === 'Img2Go'">
        <magic-editor></magic-editor>
      </div>

    </div>
    <div class="sidebar-right-bot">
      <creations v-if="this.creatorStudio.isMobile === true"></creations>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import user from './../../mixins/user.mixin'
import ExportBtn from "../Elements/ExportBtn.vue";
import ContinueWith from "../Elements/ContinueWith.vue";
import Creations from "../Elements/Creations.vue";
import Feedback from "../Elements/Feedback.vue";
import JobQueued from "../Elements/JobQueued.vue";
import currentJob from "../../mixins/current_job.mixin";
import QueuePlaceInQueue from "../Elements/QueueState/QueuePlaceInQueue.vue";
import QueueGeneric from "../Elements/QueueState/QueueGeneric.vue";
import QueueProcessing from "../Elements/QueueState/QueueProcessing.vue";
import QueueComplete from "../Elements/QueueState/QueueComplete.vue";
import QueueFailed from "../Elements/QueueState/QueueFailed.vue";
import QueueFull from "../Elements/QueueState/QueueFull.vue";
import QueuePrepare from "../Elements/QueueState/QueuePrepare.vue";
import MagicEditor from "../Elements/MagicEditor.vue";
import Rating from "../Elements/Rating.vue";
import {satGlobals} from "../../../../../../sat/helper/sat-globals";

export default {
  name: "SidebarRightExport",
  props: {},
  components: {
    Rating,
    MagicEditor,
    QueuePrepare,
    QueueFull,
    QueueFailed,
    QueueComplete,
    QueueProcessing,
    QueueGeneric,
    QueuePlaceInQueue,
    JobQueued,
    ExportBtn,
    ContinueWith,
    Creations,
    Feedback
  },
  mixins: [
    store,
    currentJob,
      user
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {
  }
};
</script>
<style lang="scss">
.feedback-item-bg {
  background-image: url('../../assets/images/feedback-bg@2x.png') !important;
  background-size: cover !important;
  background-position: center center !important;
}
</style>
